"use strict";
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-redeclare */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.log = void 0;
const util_1 = __importDefault(require("util"));
function replacer(wm) {
    return (_key, value) => {
        var _a, _b, _c, _d;
        if (value !== null && typeof value === 'object') {
            if (wm.has(value)) {
                return '[Circular]';
            }
            wm.add(value);
            if (value instanceof Error) {
                return {
                    name: value.name,
                    message: value.message,
                    stack: value.stack,
                    code: (_a = value) === null || _a === void 0 ? void 0 : _a.code,
                    errno: (_b = value) === null || _b === void 0 ? void 0 : _b.errno,
                    path: (_c = value) === null || _c === void 0 ? void 0 : _c.path,
                    syscall: (_d = value) === null || _d === void 0 ? void 0 : _d.syscall
                };
            }
        }
        return value;
    };
}
const levels = ['debug', 'info', 'warn', 'error'];
function log(...args) {
    const [level, fmt, ...params] = args;
    const metadata = params.length === 1 && typeof params[0] === 'object' && params[0] !== null;
    const message = util_1.default.format(fmt, ...(metadata ? [] : params));
    const ts = new Date().toISOString();
    const wm = new WeakSet();
    // eslint-disable-next-line no-console
    console[level](JSON.stringify({
        ts,
        level: level.toUpperCase(),
        message,
        metadata: metadata ? params[0] : undefined
    }, replacer(wm)));
}
exports.log = log;
//# sourceMappingURL=index.js.map